import { render, staticRenderFns } from "./RecipePurchaseModal.vue?vue&type=template&id=6df9ca51&scoped=true&"
import script from "./RecipePurchaseModal.vue?vue&type=script&lang=js&"
export * from "./RecipePurchaseModal.vue?vue&type=script&lang=js&"
import style0 from "./RecipePurchaseModal.vue?vue&type=style&index=0&id=6df9ca51&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6df9ca51",
  null
  
)

export default component.exports